module.exports = __webpack_public_path__ + "static/media/toyota-logo-charcoal.8102339b.svg";